import { useMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import type { UseMutationProps } from '@ztechapps/common.hook'
import type { CustomerAndCompany, UpdateCompanyStatusWithSubCompaniesArgs } from '@ztechapps/common.contract'

const COMPANY_UPDATE_STATUS_MUTATION = gql`
  mutation companyUpdateStatusWithSubCompanies($input: UpdateCompanyStatusWithSubCompaniesArgs!) {
    companyUpdateStatusWithSubCompanies(input: $input) {
      _id
      company {
        _id
        name
        status
      }
    }
  }
`

export const useUpdateCompanyStatusWithSubCompanies = (props?: Partial<UseMutationProps>) => {
  return useMutation<CustomerAndCompany, UpdateCompanyStatusWithSubCompaniesArgs>({
    query: COMPANY_UPDATE_STATUS_MUTATION,
    ...props,
  })
}
